const isEmpty = require("is-empty");
const initialState = {
    isAuthenticated: false,
    bot: {},
    loading: false
};
export default function(state = initialState, action) {
    switch (action.type) {
       
        case 'BOT_ADD':
        return {
                isAuthenticated: !isEmpty(action.payload),
                bot: action.payload
        };
      
        case 'BOT_UPDATE':
            return {
                isAuthenticated: !isEmpty(action.payload),
                bot: action.payload,
            };
        case 'BOT_CURRENT_ROLE':
            return {
                ...state,
                isAuthenticated: !isEmpty(action.payload),
                bot: action.payload
            };  
            
        case 'BOT_LOADING':
            return {
                ...state,
                loading: true
            };
        default:
            return state;
    }
}
